<div [ngClass]="classeModeApplication" class="position-relative alerts w-100">
	<div class="position-absolute w-100">
		<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alert-dismissable mb-0 w-100 d-flex">
			<div [innerHTML]="alert.message | translate:alert.msgParams" *ngIf="!modeApplicationCohabitation"></div>
			<a class="close" [hidden]="alert.onClickFunction" (click)="removeAlert(alert)"><i class="fas fa-times fa-fw"></i></a>
			<div [innerHTML]="alert.message | translate:alert.msgParams" *ngIf="modeApplicationCohabitation"></div>
			<button *ngIf="alert.onClickFunctionBouton2" class="bouton-ok btn btn-link" (click)="onClickFunctionBouton2(alert)" [disabled]="loading">{{ nomBouton2 | translate }}</button>
			<button *ngIf="alert.onClickFunction" class="bouton-ok btn btn-link" (click)="onClickFunction(alert)" [disabled]="loading">{{ nomBouton | translate }}</button>
		</div>
	</div>
</div>
